export default "__VITE_PUBLIC_ASSET__54715f6d__"